import { Box, Select, Option, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { Shield } from "lucide-react";

interface ISkylightFlashingKit {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}

/**
 * Skylight flashing kit type — dome kit vs step flashing kit.
 * Maps to separate Xactimate line items.
 */
export function SkylightFlashingKit(props: ISkylightFlashingKit) {
    const { value, onChange, loading } = { ...props };
    const [kit, setKit] = useState<string | null>(null);

    const handleUpdate = (event: any, newValue: string | null) => {
        if (loading) return;
        const selectedValue = newValue || "";
        setKit(selectedValue);
        onChange(selectedValue);
    };

    useEffect(() => {
        if (value) {
            setKit(value);
        }
    }, [value]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Flashing Kit
            </Typography>

            <Select
                placeholder="Select flashing kit"
                value={kit}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<Shield size={16} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                <Option value="Dome Kit">Dome Kit</Option>
                <Option value="Step Flashing Kit">Step Flashing Kit</Option>
                <Option value="N/A">N/A</Option>
            </Select>
        </Box>
    );
}
